export { default } from './ConfirmationCode';
